import React, { useEffect, useRef, useState } from "react";
import { getVideoDetails } from "./service"
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import VideoJS from '../../Components/VideoJsPlayer/VideoJS';
import { convertAdUrl, getEventInfo, imageUrlCheck, isHTML, onVideoPlayFunction } from "../../utils/utils";
import { getVideoSubscription } from "../Subscription/service";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import { getPlayerToken, updateVideoWatchlistData, getUserSubscription, updateWatchlistData, authenticate } from "../../network/service";
import { getMoreInfoOther } from "../../Redux/MoreInfo/moreInfoOtherSlice";
import { getMoreInfo } from "../../Redux/MoreInfo/moreInfoSlice";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import WatchWithoutAdsModal from "../../Components/Modals/WatchWithoutAdsModal";
import ContinueWatchingModel from "../../Components/Modals/ContinueWatchingModel";
import Loading from "../../Components/Loading/Loading";
import { ReactComponent as LeftArrow } from "../../assets/Icons/leftArrow.svg";
import ShowCard from "../../Components/ShowCard/ShowCard";
import Select from "react-select";
import Comment from "./Components/Comment";
import Autoplay from "./Components/Autoplay";
import LogoutAllModal from "../../Components/Modals/LogoutAllModal";
import Translate from "../../Components/Multilanguage/Translate";

let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let videoPlaying = false;

function VideoPlayer() {
    const location = useLocation()
    const videoId = location?.state?.videoDetails?.video_id;
    const { vanityUrl } = useParams()
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const accessToken = useSelector((state) => state?.accessToken?.value);
    const userSubscriptionData = useSelector((state) => state?.userSubscription?.value);
    const sessionId = useSelector((state) => state?.sessionId?.value);
    const user = useSelector((state) => state?.user?.value);
    const isLive = location?.state?.isLive;
    const [videoUrl, setVideoUrl] = useState();
    const [adUrl, setAdUrl] = useState("");
    const [videoDetails, setVideoDetails] = useState();
    const [videoTitle, setVideoTitle] = useState("");
    const [poster, setPoster] = useState("");
    const [subscriptions, setSubscriptions] = useState();
    const [loading, setLoading] = useState(true);
    const [watchListStatus, setWatchListStatus] = useState();
    const [vPlayer, setVPlayer] = useState();
    const [subscribedUser, setSubscribedUser] = useState(true);
    const [isContinueWatchingModal, setIsContinueWatchingModal] = useState(false);
    const [watchWithoutAds, setWatchWithoutAds] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [subtitleInfo, setSubTitleInfo] = useState();
    const [closedCaptionInfo, setClosedCaptionInfo] = useState();
    const [watchedDuration, setWatchedDuration] = useState();
    const [isAutoplayView, setIsAutoplayView] = useState(false);
    const [watchedTime, setWatchedTime] = useState(0);
    const [multiLanguageOptions, setMultiLanguageOptions] = useState([]);
    const [selectedAudioLanguage, setSelectedAudioLanguage] = useState({});
    const [upNext, setUpNext] = useState([]);
    const [modalType, setModalType] = useState({ type: "logoutAll" });
    const [logoutModal, setLogoutModal] = useState(false);
    const [descExpanded, setDescExpanded] = useState(false);
    const [descOverflow, setDescOverflow] = useState(false); // true if collapsed content overflows
    const [descOverflowChecked, setDescOverflowChecked] = useState(false); // true if we've checked overflow at least once
    const descRef = useRef(null);

    const playerRef = useRef(null);
    const currentAdUrlRef = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();


    const showDetails = location?.state?.showDetails
    const showId = location?.state?.showId || showDetails?.show_id;
    const isMoreInfoOther = useSelector((state) => state?.moreInfoOther?.value);

    const videoType = (location?.state?.showDetails?.type == "linear_event" || location?.state?.type == "linear_event") ? "event" : "video";
    let showUniqueId = isMoreInfoOther?.showId ? isMoreInfoOther?.showId : showId;
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: 'transparent',
            '&:hover': {
                borderColor: 'grey',
            },

        }),

        menu: (provided) => ({
            ...provided,
            top: '100%',
            bottom: 'auto',
            backgroundColor: 'white',
        }),
        menuList: (provided) => ({
            ...provided,
            maxHeight: '200px',
        }),

        singleValue: (provided) => ({
            ...provided,
            color: 'grey',
        }),

        placeholder: (provided) => ({
            ...provided,
            color: 'black',
        }),
    };

    const appInfo = {
        projectDetails: projectInfo,
        accessToken: accessToken,
        sessionId,
    };
    // Only check for overflow when not expanded, and remember if it was ever overflowing
    useEffect(() => {
        if (descRef.current && videoDetails?.video_description && !descExpanded) {
            const el = descRef.current;
            const isOverflowing = el.scrollHeight > el.clientHeight + 2;
            setDescOverflow(isOverflowing);
            setDescOverflowChecked(true);
        }
    }, [videoDetails?.video_description, descExpanded]);
    
    useEffect(() => {
        if (location.state?.videoDetails && location.state?.videoDetails?.video_type !== 'playlist') {
            localStorage.removeItem('playlist_show_id');
            localStorage.removeItem('playlist_vanity_url');
        }
        
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        setVPlayer(null);
        setLoading(true);
        setWatchedTime(0);
        setWatchedDuration(0);
        currentAdUrlRef.current = undefined;
        fetchVideoDetails();
    }, [location?.pathname]);

    useEffect(() => {
        window.scroll(0, 0)
        setVPlayer(null)

        if (videoDetails) {
            if (videoDetails?.ad_link) {
                setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
            } else {
                setAdUrl(null);
            }
            handleVideoPlayback();
        }
    }, [videoDetails, subscriptions]);

    useEffect(() => {
        setVPlayer(null);
        if (videoUrl) {
            const videoJsOptions = {
                autoplay: true,
                controls: true,
                responsive: true,
                fluid: true,
                controlBar: {
                    pictureInPictureToggle: false,
                },
                sources: [
                    {
                        src: `${videoUrl}`,
                        type: "application/x-mpegURL",
                    },
                ],
            };

            const effectiveAdUrl = currentAdUrlRef.current !== undefined ? currentAdUrlRef.current : adUrl;
            setVPlayer(
                <VideoJS
                    options={videoJsOptions}
                    onReady={handlePlayerReady}
                    adUrl={effectiveAdUrl}
                    subtitles={subtitleInfo}
                    poster={poster}
                />
            );
        }
    }, [videoUrl]);
    const fetchVideoSubscription = async (videoId) => {
        const type = "video";
        try {
            return await getVideoSubscription(appInfo, videoId, type);
        } catch (err) { }
    };

    const fetchUserSubscriptionDetails = async () => {
        const userSubResponse = await getUserSubscription(appInfo);
        if (userSubResponse?.status === 200) {
            dispatch(
                getUserSubscriptionData({
                    userSubscription: userSubResponse?.data,
                })
            );
        }
    };

    const updateVideoAnalytics = async (event, time) => {
        const shouldIncludeShowId = videoDetails?.video_type === 'playlist';
        const updateResponse = await onVideoPlayFunction(
            appInfo,
            videoDetails,
            event,
            time,
            "0",
            location?.state?.categories,
            shouldIncludeShowId ? showDetails?.show_id : null
        );
    };

    const handleErrorResponse = (response, showId) => {
        if (response?.status === 401) {
            const showVanity = response?.data?.data?.show_vanity_url || location?.state?.showDetails?.vanity_url;
            const fallbackPath = showVanity ? `/show-details/${showVanity}` : "/home";
            const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || fallbackPath;
            navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true" ? "/checkout" : "/login", {
                replace: true,
                state: {
                    ...location.state,
                    isFree: response?.data?.data?.free_video || false,
                    path: location?.pathname,
                    showId: showId,
                    isFrom: true,
                    from: "VideoPlayer",
                    prevPath: resolvedPrevPath,
                    activeLogin: true,
                    videoId: response?.data?.data?.video_id,
                }
            });
            return true;
        } else if (response?.status === 403) {
            const checkoutUrl = response?.data?.data?.checkout_link || response?.data?.data?.checkout_url;
            if (checkoutUrl) {
                window.open(checkoutUrl, "_self");
            } else {
                const showVanity = response?.data?.data?.show_vanity_url || location?.state?.showDetails?.vanity_url;
                const fallbackPath = showVanity ? `/show-details/${showVanity}` : "/home";
                const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || fallbackPath;
                if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
                navigate("/checkout", {
                    replace: true,
                    state: { videoId: response?.data?.data?.video_id, isFree: response?.data?.data?.free_video || false, from: "VideoPlayer", prevPath: resolvedPrevPath }
                });
                } else {
                navigate("/subscription", {
                    replace: true,
                    state: { videoId: response?.data?.data?.video_id, isFree: response?.data?.data?.free_video || false, from: "VideoPlayer", prevPath: resolvedPrevPath }
                });
                }
            }
            return true;
        }
        return false;
    };

    const fetchVideoDetails = async () => {
        try {
            await fetchUserSubscriptionDetails();
            
            const currentShowId = location?.state?.showId || location?.state?.showDetails?.show_id;
            const storedPlaylistShowId = localStorage.getItem('playlist_show_id');
            const storedVanityUrl = localStorage.getItem('playlist_vanity_url');
            let effectiveShowId = currentShowId;
            
            if (!effectiveShowId && storedVanityUrl === vanityUrl && storedPlaylistShowId) {
                effectiveShowId = storedPlaylistShowId;
            } else if (storedVanityUrl === vanityUrl && storedPlaylistShowId && !currentShowId) {
                effectiveShowId = storedPlaylistShowId;
            }
            
            const response = await getVideoDetails(vanityUrl, appInfo, effectiveShowId);
            if (handleErrorResponse(response, effectiveShowId)) {
                return;
            }
            if (response?.status === 200) {
                setMultiLanguageOptions(response.data.data.audio_languages);
                const videoSubResponse = await fetchVideoSubscription(response?.data?.data?.video_id);
                if (videoSubResponse?.status === 200) {
                    setVideoDetails(response?.data?.data);
                    setVideoTitle(response?.data?.data?.video_title);
                    setPoster(response?.data?.data?.thumbnail_350_200);
                    setUpNext(response?.data?.data?.up_next);
                    setSubscriptions(videoSubResponse?.data?.data);
                    setLoading(false);
                    if (response?.data?.data?.watchlist_flag === 1) setWatchListStatus("added");
                    
                    if (response?.data?.data?.video_type === 'playlist' && effectiveShowId) {
                        localStorage.setItem('playlist_show_id', effectiveShowId);
                        localStorage.setItem('playlist_vanity_url', vanityUrl);
                    }
                } else {
                    setWatchListStatus("removed");
                }
            }
        } catch (err) {
            setLoading(false);
        }
    };
    const multiLanguageDropdownHandler = async (selectedOption) => {
        setSelectedAudioLanguage({ value: selectedOption.value, label: selectedOption.label, video_name: selectedOption.video_name })
        setWatchedTime(playerRef.current.currentTime())
        setVideoTitle(selectedOption.video_title)
        
        if (selectedOption.video_time && selectedOption.audio) {
            startPlaying(selectedOption.video_time, selectedOption.audio);
        } else {
            createVideoUrl(selectedOption);
        }
    }
    const subscriptionCheck = (userSub, videoSub, isFreeVideo = false) => {
        if (isFreeVideo) {
            return Array.isArray(userSub) && userSub.length > 0;
        }
        const hasMatch = userSub?.some((user) => videoSub?.some((video) => user.sub_id === video?.subscription_id));
        return hasMatch;
    };

    const createVideoUrl = async (video) => {
        const showId = location?.state?.showId || 
                      location?.state?.showDetails?.show_id || 
                      localStorage.getItem('playlist_show_id');
        const response = await getVideoDetails(video.value, appInfo, showId);
        if (handleErrorResponse(response, showId)) {
            return;
        }
        setUpNext(response?.data?.data?.up_next);
        const arr = video?.video_name?.split("/").reverse();
        const videoTime = response?.data?.data?.video_time || arr[1];
        const audio = response?.data?.data?.audio;
        
        if (showId && response?.data?.data?.video_type === 'playlist') {
            localStorage.setItem('playlist_show_id', showId);
            localStorage.setItem('playlist_vanity_url', video.value);
        }
        
        startPlaying(videoTime, audio);
    }

    const isStartOver = location?.state?.isStartOver === true || location?.state?.continueWatch === false || location?.state?.videoDetails?.watched_duration === 0;

    const playVideo = async (watchedLength, customAdUrl = undefined) => {
        setShowVideo(true);
        // if (watchedLength) {
        //     setWatchedDuration(watchedLength);
        // }
        let dur = 0;
        if (isStartOver) {
            dur = 0;
        } else if (typeof watchedLength === 'number') {
            dur = watchedLength;
        } else if (watchedLength && typeof watchedLength.watched_duration !== 'undefined') {
            dur = Number(watchedLength.watched_duration) || 0;
        } else if (videoDetails && typeof videoDetails.watched_duration !== 'undefined') {
            dur = Number(videoDetails.watched_duration) || 0;
        }
        setWatchedDuration(dur);
        
        if (customAdUrl !== undefined) {
            setAdUrl(customAdUrl);
            currentAdUrlRef.current = customAdUrl;
        }
        
        setSubTitleInfo(videoDetails?.subtitles);
        setClosedCaptionInfo(videoDetails?.closed_captions);
        const arr = videoDetails?.video_name?.split("/").reverse();
        const audio = videoDetails?.audio;
        const videoTime = videoDetails?.video_time || arr[1];
        startPlaying(videoTime, audio);
    };
    
    const startPlaying = async (videoTime, audio) => {
        const playerTokenData = await fetchPlayerToken(videoTime);

        if (playerTokenData) {
            setVPlayer(null);
            if (audio) {
                setVideoUrl(
                    "https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=" +
                    videoTime +
                    "&token=" +
                    playerTokenData +
                    "&type=" +
                    videoType +
                    "&pubid=" +
                    projectInfo?.projectConfig?.pubid +
                    "&audio=" + audio
                );
            } else {
                setVideoUrl(
                    "https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=" +
                    videoTime +
                    "&token=" +
                    playerTokenData +
                    "&type=" +
                    videoType +
                    "&pubid=" +
                    projectInfo?.projectConfig?.pubid
                );
            }
        }
    };

    const fetchPlayerToken = async (videoId) => {
        const playerTokenResponse = await getPlayerToken(appInfo, videoId);
        if (playerTokenResponse?.status === 200) {
            return playerTokenResponse?.data?.data;
        }
    };

    const handlePlayerReady = (player) => {
        playerRef.current = player;
        player.on("play", () => {
            let event = videoStarted == true ? "POP09" : "POP02";
            videoStarted = true;
            videoPlaying = true;
            updateVideoAnalytics(event, player.currentTime());
        });
        player.on("loadedmetadata", () => {
            // player.pause();
            if (watchedTime > 0) {
                player.currentTime(watchedTime.toString());
                // player.play();
                // videoPlaying = true;

            } else if (watchedDuration > 0) {
                player.currentTime(watchedDuration.toString());
                // player.play();
                // videoPlaying = true;
            }
            else {
                // player.play();
                // videoPlaying = true;
            }
        });
        player.on("timeupdate", function (e) {
            let event = "POP03";
            videoPlaying = true;
            var hasPlayedTime = player.currentTime();
            var intPlayedTime = parseInt(hasPlayedTime, 10);
            var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
            if (isSixty && debounce) {
                debounce = false;
                prevTime = intPlayedTime;
                updateVideoAnalytics(event, player.currentTime());
            } else {
                if (debounce == false && prevTime != intPlayedTime) {
                    debounce = true;
                }
            }
        });

        player.on("pause", () => {
            let event = "POP04";
            videoPlaying = true;
            updateVideoAnalytics(event, player.currentTime());
        });
        player.on("ended", () => {
            let event = "POP05";
            videoPlaying = false;
            // episodeCount = findIndex() + 1;
            updateVideoAnalytics(event, player.currentTime());
            
            if (videoDetails?.video_type === "playlist") {
                const currentIndex = videoDetails.up_next.findIndex(
                    (video) => video.video_id === videoDetails.video_id
                );

                if (currentIndex < videoDetails.up_next.length - 1) {
                    setIsAutoplayView(true);
                }
            }

            if (videoDetails?.video_type !== "playlist" && videoDetails?.up_next?.length > 0) {
                setIsAutoplayView(true);
            }
        });
        player.on("dispose", () => {
            videoPlaying = false;
            videoStarted = false;
            player.pause();
        });
        player.on('keydown', (e) => {
            if (e.which === 32 || e.which === 13) {
                e.preventDefault();
                if (player.paused()) {
                    player.play();
                } else {
                    player.pause();
                }
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 37) {
                e.preventDefault();
                player.currentTime(player.currentTime() - 10);
            } else if (e.which === 39) {
                e.preventDefault();
                player.currentTime(player.currentTime() + 10);
            }
        });
        player.on('keydown', (e) => {
            if (e.which === 70 || e.which === 102) {
                e.preventDefault();
                player.requestFullscreen();
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 38) {
                e.preventDefault();
                player.volume(player.volume() + 1);
            } else if (e.which === 40) {
                e.preventDefault();
                player.volume(player.volume() - 0.1);
            }
        });

        player.on('keydown', (e) => {
            if (e.which === 77 || e.which === 109) {
                e.preventDefault();
                player.muted(!player.muted());
            }
        });
        player.ready(() => {
            player.el().focus();
        });
    };

    const handleVideoPlayback = async () => {
        if (logoutLimitCheck()) {
            return;
        }
        if (subscriptions?.length === 0) {
            if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "true") {
                if (!user) {
                    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' && !videoDetails?.free_video) {
                        localStorage.setItem("showId", showDetails?.show_id);
                        localStorage.setItem("vanityUrl", videoDetails?.vanity_url);
                        navigate("/checkout", { state: { videoId: videoDetails?.video_id } });
                    } else {
                        navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout" : "/login", { state: { ...location.state, path: location?.pathname, showId: showId, isFrom: true, activeLogin: true } });
                    }
                }
                else if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
                    if (subscriptionCheck(userSubscriptionData?.data, subscriptions, videoDetails?.free_video)) {
                        // setAdUrl(null);
                        playVideo();
                    } else {
                        // setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
                        playVideo();
                    }
                } else {
                    playVideo();
                }
            }
            else if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
                if (userSubscriptionData?.login_needed === false) {
                    handleClose();
                    if (subscriptionCheck(userSubscriptionData?.data, subscriptions, videoDetails?.free_video)) {
                        // setAdUrl(null);
                        playVideo();
                    } else {
                        // setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
                        playVideo();
                    }
                } else if (userSubscriptionData?.login_needed === true) {
                    setModalType({ type: "videoWatchLimitExpired" });
                    setLogoutModal(true);
                }
                else {
                    if (subscriptionCheck(userSubscriptionData?.data, subscriptions, videoDetails?.free_video)) {
                        // setAdUrl(null);
                        playVideo();
                    } else {
                        // setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
                        playVideo();
                    }
                }
            }
            else {
                if (userSubscriptionData?.login_needed === false) {
                    handleClose();
                    playVideo();
                } else if (userSubscriptionData?.login_needed === true) {
                    setModalType({ type: "videoWatchLimitExpired" });
                    setLogoutModal(true);
                }
                else {
                    playVideo();
                }
            }
        }
        else if (subscriptions?.length > 0 && videoDetails?.free_video) {

            logoutLimitCheck();
            if (subscriptionCheck(userSubscriptionData?.data, subscriptions, videoDetails?.free_video)) {
                // setAdUrl(null);
                playVideo();
            } else {
                // setWatchWithoutAds(true);
                playVideo();
            }
        }
        else {

            logoutLimitCheck();
            if (subscriptionCheck(userSubscriptionData?.data, subscriptions, videoDetails?.free_video)) {
                // setAdUrl(null);
                playVideo();
            } else {
                if (!user) {
                    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' && !videoDetails?.free_video) {
                        localStorage.setItem("showId", showDetails?.show_id);
                        localStorage.setItem("vanityUrl", videoDetails?.vanity_url);
                        navigate("/checkout", { state: { videoId: videoDetails?.video_id } });
                    } else {
                        navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout" : "/login", { state: { ...location.state, path: location?.pathname, showId: showId, isFrom: true,activeLogin: true } });
                    }
                } else {
                    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true') {
                        localStorage.setItem("showId", showDetails?.show_id);
                        localStorage.setItem("vanityUrl", videoDetails?.vanity_url);
                        navigate("/checkout", { state: { videoId: videoDetails?.video_id } });
                    } else {
                        navigate("/subscription", { state: { videoId: videoDetails?.video_id } });
                    }
                }
            }

        }
    };
    const logoutLimitCheck = () => {
        if (userSubscriptionData?.forcibleLogout === true) {
            setLogoutModal(true);
            setModalType({
                type: "logoutAll",
                heading: "You’ve reached the maximum Device limit.Do you want to logout from all devices",
            });
            return true;
        } else if (userSubscriptionData?.session_expired === true) {
            setModalType({ type: "redirect" });
            setLogoutModal(true);
            setTimeout(() => {
                handleClose();
                redirectToLogin();
            }, 1000);
            return true;
        }
        return false;
    }
    const handleClose = () => {
        document.body.className = "hideScroll";
        if (isMoreInfoOther?.isModal) {
            if (isMoreInfoOther?.isFromSearch) {
                if (location?.state?.isFromHome) {
                    navigate("/home");
                }
                setTimeout(() => {
                    dispatch(
                        getMoreInfoOther({
                            isModal: false,
                            showId: null,
                            isFromSearch: false,
                        })
                    );
                }, 600);
            } else {
                setTimeout(() => {
                    dispatch(
                        getMoreInfoOther({
                            isModal: false,
                            showId: null,
                        })
                    );
                }, 600);
            }
        } else {
            setTimeout(() => {
                dispatch(
                    getMoreInfo({
                        moreInfo: false,
                    })
                );
            }, 500);
        }

    };
    const redirectToLogin = () => {
        dispatch(
            getUser({
                user: null,
            })
        );
        localStorage.removeItem("userId");
        tokenAuthenticate();
        navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == "true" ? "/checkout" : "/login", {
            state: { path: location?.pathname, showId: showUniqueId, activeLogin: true },
        });
    };
    const tokenAuthenticate = async () => {
        const response = await authenticate(appInfo);
        if (response?.status === 200) {
            dispatch(
                getAccessToken({
                    accessToken: response?.data?.token,
                })
            );
        }
    };
    const goBack = () => {
        window.history.back();
    };
    

    const handlePlaylistVideoChange = async (newVideo, passedShowId) => {
        setVPlayer(null);

        try {
            const showId = passedShowId || location?.state?.showId || location?.state?.showDetails?.show_id || localStorage.getItem('playlist_show_id');
            const response = await getVideoDetails(newVideo.vanity_url, appInfo, showId);

            if (response?.status === 200) {
                const freshVideoData = {
                    ...response.data.data,
                    video_type: 'playlist',
                    vanity_url: response.data.data.vanity_url || newVideo.vanity_url
                };

                const videoSubResponse = await fetchVideoSubscription(freshVideoData.video_id);
                
                setVideoDetails(freshVideoData);
                setVideoTitle(freshVideoData.video_title);
                setPoster(freshVideoData.thumbnail_350_200);
                setWatchedTime(0);
                setWatchedDuration(0);
                setUpNext(freshVideoData.up_next || []);
                setMultiLanguageOptions(freshVideoData.audio_languages || []);
                setSubTitleInfo(freshVideoData.subtitles);
                setClosedCaptionInfo(freshVideoData.closed_captions);
                
                if (videoSubResponse?.status === 200) {
                    setSubscriptions(videoSubResponse?.data?.data);
                }

                const vanityUrl = freshVideoData.vanity_url || newVideo.vanity_url;
                
                if (showId) {
                    localStorage.setItem('playlist_show_id', showId);
                    localStorage.setItem('playlist_vanity_url', vanityUrl);
                }
                
                window.history.replaceState(
                    { 
                        videoDetails: freshVideoData,
                        showId: showId
                    },
                    '',
                    `/videos/${vanityUrl}`
                );

                const videoTime = freshVideoData?.video_time || 0;
                const audio = freshVideoData?.audio;
                startPlaying(videoTime, audio);
            }
        } catch (error) {
            console.error("Error fetching video details:", error);

            const updatedVideo = {
                ...newVideo,
                video_type: 'playlist'
            };

            try {
                const videoSubResponse = await fetchVideoSubscription(updatedVideo.video_id);
                if (videoSubResponse?.status === 200) {
                    setSubscriptions(videoSubResponse?.data?.data);
                } else {
                    setSubscriptions([]);
                }
            } catch (subError) {
                console.error("Error fetching subscription details:", subError);
                setSubscriptions([]);
            }

            setVideoDetails(updatedVideo);
            setVideoTitle(updatedVideo.video_title);
            setPoster(updatedVideo.thumbnail_350_200);

            const vanityUrl = updatedVideo.vanity_url || newVideo.vanity_url;
            
            const showId = passedShowId || location?.state?.showId || location?.state?.showDetails?.show_id || localStorage.getItem('playlist_show_id');
            
            if (showId) {
                localStorage.setItem('playlist_show_id', showId);
                localStorage.setItem('playlist_vanity_url', vanityUrl);
            }
            
            window.history.replaceState(
                { 
                    videoDetails: updatedVideo,
                    showId: showId
                },
                '',
                `/videos/${vanityUrl}`
            );
            const videoTime = updatedVideo?.video_time || 0;
            const audio = updatedVideo?.audio;
            startPlaying(videoTime, audio);
        }
    };
    const navigateToCategoryShowsListing = (vanityUrl) => {
        navigate(`/category/${vanityUrl}`, { state: { careers: vanityUrl } })
    }
    const searchHandler = (value, type) => {
        navigate(`/search?query=${value}`, { state: { type } });
    };

    if (loading) {
        return <Loading />;
    }
    return (
        <div className='videoPlayerContainer'
            style={{
                backgroundColor: projectInfo?.projectConfig?.config?.BACKGROUND_COLOR || "var(--secondary-bg-color)"
            }}>
            <div className='wrapper'>
                {/* {watchWithoutAds &&
                    <WatchWithoutAdsModal
                        setWatchWithoutAds={setWatchWithoutAds}
                        showDetails={showDetails}
                        appInfo={appInfo}
                        setAdUrl={setAdUrl}
                        videoDetails={videoDetails}
                        watchDuration={watchedDuration}
                        playVideo={playVideo}
                        setIsContinueWatching={setIsContinueWatchingModal}
                    />
                )}
                {isContinueWatchingModal && (
                    <ContinueWatchingModel
                        setIsContinueWatchingModal={setIsContinueWatchingModal}
                        videoDetails={videoDetails}
                        playVideo={playVideo}
                        showDetails={showDetails}
                        appInfo={appInfo}
                        setAdUrl={setAdUrl}
                        subscribedUser={subscribedUser}
                    />
                )} */}
                {logoutModal && (
                    <LogoutAllModal
                        showId={showUniqueId}
                        appInfo={appInfo}
                        setLogoutModal={setLogoutModal}
                        modalType={modalType}
                        videoDetails={videoDetails}
                        handleClose={handleClose}
                    />
                )}
                {/* <div className="arrowContainer" onClick={goBack}>
                    <h3>
                        <LeftArrow />
                    </h3>
                </div> */}

                <div className={`topContainer ${videoDetails?.video_type === 'playlist' ? "playlist" : ""}`}>
                    <div className={`playerContainer ${videoDetails?.video_type === 'playlist' ? "playlist" : ""}`}>
                        {vPlayer && (
                            <>
                                {videoDetails?.watermark && (
                                    <img
                                        src={videoDetails.watermark}
                                        alt="Watermark"
                                        className="watermark"
                                    />
                                )}
                                {vPlayer}
                            </>
                        )}
                        {
                            isAutoplayView &&
                            <Autoplay 
                                episodes={videoDetails?.up_next} 
                                setIsAutoplayView={setIsAutoplayView} 
                                isPlaylist={videoDetails?.video_type === 'playlist'} 
                                onVideoChange={handlePlaylistVideoChange} 
                                currentVideoId={videoDetails?.video_id}
                            />
                        }
                    </div>
                    {videoDetails?.video_type === 'playlist' && (
                        <div className="upNextSidebar">
                            <h1 className="heading">
                                {upNext?.length} <Translate textKey={'videos'} />
                            </h1>
                            <div className="upNextList">
                                {upNext?.map((video) => (
                                    <div
                                        className={`upNextItem ${video.video_id === videoDetails.video_id ? "selected" : ""}`}
                                        key={video.id || video.video_id}
                                        onClick={() => {
                                            const showId = location?.state?.showId || 
                                                          location?.state?.showDetails?.show_id || 
                                                          localStorage.getItem('playlist_show_id');
                                            handlePlaylistVideoChange(video, showId);
                                        }}
                                    >
                                        <div className='upNextTop'>
                                            <div className="upNextThumbnail">
                                                <img
                                                    src={video.thumbnail_350_200}
                                                    alt={video.video_title}
                                                />
                                            </div>
                                            <div className="metaData">
                                                <div className="upNextTitle">
                                                    {video?.video_title}
                                                </div>
                                                <div className="upNextDuration">
                                                    {video?.duration_text}
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`upNextDescription ${video.video_id === videoDetails.video_id ? "visible" : ""}`}>
                                            {isHTML(video?.video_description)
                                                ? <span dangerouslySetInnerHTML={{ __html: video?.video_description }} />
                                                : video?.video_description}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <div className="multiAudio" >
                    {multiLanguageOptions?.length > 1 &&
                        <div className="selectContainer">
                            <Select
                                styles={customStyles}
                                options={multiLanguageOptions.map((video) => ({
                                    value: video.video_id,
                                    label: video.language_name,
                                    video_name: video.video_name,
                                    video_title: video.video_title
                                }))}
                                placeholder={"Choose Language..."}
                                onChange={multiLanguageDropdownHandler}
                                value={selectedAudioLanguage && Object.keys(selectedAudioLanguage)?.length !== 0 ? selectedAudioLanguage : null}
                            />
                        </div>}
                </div>

                <div className="videoMetaData">
                    <div className="head">
                        <h1 className="videoTitle">{videoTitle}</h1>
                    </div>
                    <div className="categoriesAndRating">
                        <div className="categories">
                            { videoDetails?.categories?.map((item, index) => (
                                <span className="category" onClick={() => { navigateToCategoryShowsListing(item?.key) }} role="button" tabIndex={0} aria-label={`View category ${item?.category_name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { navigateToCategoryShowsListing(item?.key); } }}>{item?.category_name}</span>
                            ))}
                        </div>

                    </div>

                    {videoDetails?.go_ads_free && (
                        <div className="watchNow">
                            <button
                                className="btn text-uppercase px-4 py-2"
                                style={{
                                width: 'fit-content',
                                minWidth: '140px',
                                backgroundColor: projectInfo?.projectConfig?.config?.BUTTON_COLOR || 'var(--button-color)',
                                color: projectInfo?.projectConfig?.config?.BUTTON_TEXT_COLOR || 'var(--button-text-color)',
                                borderColor: projectInfo?.projectConfig?.config?.BUTTON_COLOR || 'var(--button-color)'
                                }}
                                onClick={() => {
                                    if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
                                        navigate("/checkout", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true, from: "VideoPlayer", prevPath: location?.state?.prevPath } });
                                    } else {
                                        navigate("/subscription", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true, from: "VideoPlayer", prevPath: location?.state?.prevPath } });
                                    }
                                }}
                            >
                                <Translate textKey={'go_ads_free'} />
                            </button>
                        </div>
                    )}

                    <div className="descriptionWrapper">
                        <p
                            className={"description" + (descExpanded ? " expanded" : "")}
                            ref={descRef}
                        >
                            {videoDetails?.video_description && (
                                isHTML(videoDetails?.video_description)
                                    ? <span dangerouslySetInnerHTML={{ __html: videoDetails?.video_description }} />
                                    : videoDetails?.video_description
                            )}
                        </p>
                        <span>
                        {(descOverflowChecked && descOverflow) && (
                            <button
                                className="viewMoreBtn"
                                onClick={() => setDescExpanded((prev) => !prev)}
                            >
                                {descExpanded ? "View Less" : "View More"}
                            </button>
                        )}
                        </span>
                       
                    </div>


                    <div className="extraInfoContainer">
                        {videoDetails?.video_tags?.length > 0 &&  (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'tags'} /></h6>
                                <div className="items oneRow">
                                    {videoDetails?.video_tags?.length > 0 &&
                                        videoDetails?.video_tags?.map((item, index) => (
                                            <span className="item" onClick={() => searchHandler(item, "tags")} role="button" tabIndex={0} aria-label={`Search tag ${item}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item, "tags"); } }}>
                                                {item}
                                                <span className="comma">,</span>
                                            </span>
                                        ))}
                                </div>
                            </div>
                        )}
                        {videoDetails?.cast?.length > 0 &&  (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'cast'} /></h6>
                                <div className="items">
                                    {videoDetails?.cast?.map((item, index) => (
                                        <div className="item" key={item?.id}>
                                            <span className="itemInfo" onClick={() => searchHandler(item?.name, "cast")} role="button" tabIndex={0} aria-label={`Search cast ${item?.name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item?.name, "cast"); } }}>
                                                {item?.name}
                                            </span>
                                            <span className="itemLabel">{item?.role}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                        {videoDetails?.crew?.length > 0 && (
                            <div className="metaItem">
                                <h6 className="subHeading"><Translate textKey={'crew'} /></h6>
                                <div className="items">
                                    {videoDetails?.crew?.map((item, index) => (
                                        <div className="item" key={item?.id}>
                                            <span className="itemInfo" onClick={() => searchHandler(item?.name, "crew")} role="button" tabIndex={0} aria-label={`Search crew ${item?.name}`} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { searchHandler(item?.name, "crew"); } }}>
                                                {item?.name}
                                            </span>
                                            <span className="itemLabel">{item?.role}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div>
                    {upNext?.length > 0 && videoDetails?.video_type !== 'playlist' && (
                        <div className="upNextContainer">
                            <h1 className="heading"><Translate textKey={'up_next'} /> {videoDetails?.season && `in Season ${videoDetails?.season}`} </h1>
                            <div className="upNext" onClick={() => setIsAutoplayView(false)}>
                                {upNext?.map((video) => (
                                    <div className={projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT" ? "itemPortrait" : "item"}>
                                        <ShowCard 
                                            data={video} 
                                            type="Episode" 
                                            showId={videoDetails?.video_type === 'playlist' ? showId : null} 
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                {projectInfo?.projectConfig?.config?.COMMENTS_REQUIRED === "true" && projectInfo?.projectConfig?.config?.WEBSITE_FIREBASE_JSON_FILE &&
                    <div className="wrapper">
                        <Comment videoId={videoDetails?.video_id} projectInfo={projectInfo} />
                    </div>
                }

            </div>
        </div>
    )
}

export default VideoPlayer

